module.exports = __webpack_public_path__ + "img/logo1.aeb18105.png";